// Global
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

// Lib
import { ComponentProps } from 'lib/component-props';
import { CardComponents, SearchComponents } from 'lib/templates/Feature.Dart.model';
import { ItemEx } from 'lib/templates/_.Sitecore.Override';

// Local
import Container from 'components/authorable/Layout/DartContainer/DartContainer';
import ProductListWithSearchWidget from 'components/ProductListWithSearch';
import { useRealPathName } from 'lib/utils/use-real-pathname';
import { sendGTMEvent } from '@next/third-parties/google';
import { GetStaticComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';

export type Result = {
  wiscj_brand_name: string | null;
};

export type ProductResultsListProps = ComponentProps &
  SearchComponents.ProductResultsListWithSearch.ProductResultsListWithSearch & {
    staticProps?: Result;
  };

export type Badge = ItemEx & CardComponents.ProductCard.Badge;

export const ProductResultsListwithSearch = (props: ProductResultsListProps): JSX.Element => {
  const [count, setCount] = useState(0);

  const router = useRouter();
  const path = useRealPathName();

  useEffect(() => {
    setCount((c) => c + 1);
  }, [router]);

  // Add ref for the GTM Event
  const hasFired = useRef(false);

  useEffect(() => {
    // Function to send the GTM event
    sendGTMEvent({ event: 'switcher', type: 'click', value: 'grid' });
    hasFired.current = true;
  }, []); // Empty dependency array ensures it runs only once on mount

  if (!props?.fields) return <></>;

  const productResultsData = {
    resultsPerPage: props?.fields?.resultsPerPage,
    noSearchResult: props?.fields?.noSearchResult,
    filterLabel: props?.fields?.filterLabel,
    sortLabel: props?.fields?.sortLabel,
    filterButtonLabel: props?.fields?.filterButtonLabel,
    sortByLabel: props?.fields?.sortByLabel,
    primaryCTAColor: props?.fields?.primaryCTAColor,
    primaryCTAType: props?.fields?.primaryCTAType,
    brandName: props?.staticProps?.wiscj_brand_name,
  };

  // Unique id for component
  const id = props?.params?.RenderingIdentifier;

  return (
    <Container>
      <div
        data-component="layout/productresultslistwithsearch"
        id={id ? id : undefined}
        tabIndex={id ? -1 : 1}
      >
        <div>
          <ProductListWithSearchWidget
            rfkId={'rfkid_12'}
            {...productResultsData}
            key={path + count}
            isBadgeFullWidth={props?.params?.isBadgeFullWidth}
          />
        </div>
      </div>
    </Container>
  );
};

export const getStaticProps: GetStaticComponentProps = async (_rendering, layoutData) => {
  let brand_name: string | null = null;
  const path = layoutData?.sitecore?.context?.itemPath;
  const path_arr = path?.split('/');
  if (path_arr?.length && path_arr?.length > 2) {
    brand_name = path_arr[2].trim().toLowerCase() || null;
  }

  const result: Result = {
    wiscj_brand_name: brand_name,
  };

  return {
    staticProps: result,
  };
};

export default ProductResultsListwithSearch;
